import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Forecast from './pages/Forecast';
import Leaderboard from './pages/Leaderboard';
import History from './pages/History';
import UserProfile from './pages/UserProfile';
import LoadingSpinner from './components/LoadingSpinner';

// Protected route wrapper
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Public route (redirect to home if already logged in)
function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        <Route path="login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />

        <Route path="register" element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        } />

        <Route path="forgot-password" element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } />

        <Route path="reset-password" element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        } />

        <Route path="forecast" element={
          <ProtectedRoute>
            <Forecast />
          </ProtectedRoute>
        } />

        <Route path="leaderboard" element={<Leaderboard />} />

        <Route path="user/:username" element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        } />

        <Route path="history" element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        } />

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
